import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

import { Text } from "@/components/ui/text";
import { cn } from "@/components/ui/utils";
import { useFileDrop } from "../hooks/useFileDrop";

type AccessionLayoutProps = HTMLAttributes<HTMLDivElement> & {
  sideDetail?: ReactNode;
  sideDetailProps?: HTMLAttributes<HTMLDivElement>;
  header?: ReactNode;
};

export const AccessionLayout = forwardRef<HTMLDivElement, AccessionLayoutProps>(
  ({ children, sideDetail, sideDetailProps = {}, header, ...props }, ref) => {
    const fileDropProps = useFileDrop();
    return (
      <div
        {...props}
        {...fileDropProps}
        className={cn(
          "flex flex-1 min-w-0 w-full relative overflow-hidden",
          props.className,
        )}
        ref={ref}
      >
        <div className="flex flex-col flex-1 min-w-0">
          {header && header}
          <div className="flex-1 min-w-0 w-full overflow-y-auto">
            <div className="flex flex-col gap-6 p-4 md:px-8 md:py-5 w-full max-w-4xl mx-auto">
              {children}
            </div>
          </div>
        </div>
        {sideDetail && (
          <div
            {...sideDetailProps}
            className={cn(
              "w-[320px] px-4 border-l hidden lg:block shrink-0 overflow-y-auto",
              sideDetailProps.className,
            )}
          >
            <div className="h-12 border-b -mx-4 px-4 flex items-center mb-4 gap-2">
              <Text size="xs" bold>
                Details
              </Text>
            </div>
            {sideDetail}
          </div>
        )}
      </div>
    );
  },
);
